import React, { useEffect, useRef, useState } from "react";
import { Grid3x3 } from "lucide-react";

// Publisher-style layout helpers: each one can be switched on or off, and holding Alt while dragging ignores them all.
export function GridMenu({ opts, set }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    const h = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h); return () => document.removeEventListener("mousedown", h);
  }, [open]);
  const on = opts.show || opts.grid;
  const Row = ({ k, label, hint }) => (
    <label className="flex items-start gap-2 py-1.5 cursor-pointer">
      <input type="checkbox" checked={!!opts[k]} onChange={(e) => set({ [k]: e.target.checked })} data-testid={`ds-grid-${k}`} className="mt-0.5 accent-[#21a6ec]" />
      <span><b>{label}</b><br /><span className="text-[11px] text-slate-500">{hint}</span></span>
    </label>
  );
  return (
    <div ref={ref} className="relative shrink-0">
      <button onClick={() => setOpen((o) => !o)} data-testid="ds-grid-btn" title="Grid & snapping"
        className={`h-8 px-2.5 inline-flex items-center gap-1.5 rounded-md text-[12px] font-bold transition-colors whitespace-nowrap ${on ? "bg-[#21a6ec] text-white" : "text-slate-200 hover:bg-white/10"}`}>
        <Grid3x3 className="h-4 w-4" />Grid
      </button>
      {open && (
        <div className="absolute right-0 top-9 z-50 w-72 bg-white text-slate-800 rounded-md shadow-2xl border border-slate-200 p-3 text-[13px]" data-testid="ds-grid-menu">
          <Row k="show" label="Show grid" hint="Faint lines on the page to line things up by eye (never printed)." />
          <Row k="grid" label="Snap to grid" hint="Items jump to the nearest grid line when you drag them." />
          <div className="flex items-center gap-1 pl-6 pb-1">
            <span className="text-[11px] text-slate-500 mr-1">Grid size</span>
            {[5, 10, 20, 50].map((v) => <button key={v} onClick={() => set({ size: v })} data-testid={`ds-grid-size-${v}`} className={`px-2 py-0.5 rounded border text-[11px] font-bold ${opts.size === v ? "bg-[#21a6ec] text-white border-[#21a6ec]" : "border-slate-300 hover:bg-slate-50"}`}>{v}px</button>)}
          </div>
          <Row k="guides" label="Smart guides" hint="Red lines + snapping to page edges, centre and other items." />
          <div className="mt-2 rounded bg-sky-50 border border-sky-200 px-2 py-1.5 text-[11px] text-slate-600">Tip: hold <b>Alt</b> while dragging to place an item freely, ignoring the grid and guides.</div>
        </div>
      )}
    </div>
  );
}
